import React from "react";
import "./Internship_Agreement_Card.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const Internship_Agreement_Card = ({
  title = "Internship Agreement",
  subTitle = "Contract",
  name,
  id,
  email,
  contact,
  uploadedBy,
  uploadDate,
  documents = [],
  note,
  status = "Signed", // Signed | Pending | Rejected
  onDownload,
  onDelete,
}) => {
  return (
    <div className="common_doc_card">
      {/* Header */}
      <div className="card_header">
        <h5>{title}</h5>
        <span className="sub_title">{subTitle}</span>
      </div>

      {/* User Info */}
      <div className="user_info_holder">
        <div className="profile_text_img_holder">
          <div>
            <div className="profile_img_holder">
              <img className="profile_img" src="/assets/images/profile/profile_1.webp" alt="profile" />
            </div>
          </div>
          <div className="user_info">
            <h6>{name}</h6>
            <p>ID- {id}</p>
          </div>
        </div>

        <div className={`status_badge ${status.toLowerCase()}`}>{status}</div>
      </div>

      {/* Contact */}
      <div className="info_block">
        <p>
          Email:- <strong className="details_text">{email}</strong>
        </p>
        <p>
          Contact:- <strong className="details_text"> {contact}</strong>
        </p>
      </div>

      {/* Upload Info */}
      <div className="info_block">
        <p>
          Uploaded by :- <strong className="details_text">{uploadedBy}</strong>
        </p>
        <p>
          Upload Date :- <strong className="details_text"> {uploadDate}</strong>
        </p>
      </div>

      {/* Documents */}
      <div className="documents_block">
        <h6>Documents Submitted</h6>
        {documents.map((item, index) => {
          const iconClass =
            item.icon === faCircleCheck
              ? "check_icon"
              : item.icon === faCircleInfo
              ? "info_icon"
              : "";

          return (
            <div key={index} className="document_item">
              <p className="list_text">{item.doc}</p>
              <FontAwesomeIcon icon={item.icon} className={iconClass} />
            </div>
          );
        })}
      </div>

      {/* Note */}

      <div className="documents_block">
        <h6>Note</h6>
        <div className="document_item">
          <p className="list_text">{note}</p>
        </div>
      </div>

      {/* Actions */}
      <div className="action_btns">
        <Button className="download_btn action_click" onClick={onDownload}>
          Download Docs
        </Button>
        <Button className="delete_btn action_click" onClick={onDelete}>
          Delete Document
        </Button>
      </div>
    </div>
  );
};

export default Internship_Agreement_Card;
